export { default, type FormLegendProps } from './FormLegend';
